<template>
  <div>
    <ul class="space-y-4">
      <li v-for="approvalRequest in approvalRequests" :key="approvalRequest.id">
        <ApprovalRequestListItem :approval-request="approvalRequest" />
      </li>
    </ul>
  </div>
</template>

<script>
import ApprovalRequestListItem from './ApprovalRequestListItem.vue';

export default {
  components: {
    ApprovalRequestListItem,
  },
  props: {
    approvalRequests: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
